import { makeObservable, isObservable } from 'mobx';
import type { AnnotationsMap } from 'mobx/dist/internal';

type MakeObservableOptions = NonNullable<Parameters<typeof makeObservable>[2]>;

/**
 * Safely calls makeObservable, preventing errors if the object
 * has already been made observable (e.g., in React Strict Mode or HMR)
 */
export const safelyMakeObservable = <
  T extends object,
  AdditionalKeys extends PropertyKey = never,
>(
  target: T,
  annotations?: AnnotationsMap<T, AdditionalKeys>,
  options?: MakeObservableOptions,
): T => {
  if (isObservable(target)) {
    return target;
  }

  return makeObservable(target, annotations, options);
};
